import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");

  useEffect(() => {
    const container = document.getElementById("waiver-container");
    if (!container) return;

    if (bookingId) {
      const iframe = document.createElement("iframe");
      iframe.src = `https://sonsguadalupe.checkfront.com/reserve/document/?template_id=1&id=${bookingId}`;
      iframe.width = "100%";
      iframe.height = "900px";
      iframe.style.border = "none";
      iframe.style.marginTop = "20px";
      container.appendChild(iframe);
    } else {
      container.innerText = "Booking ID not found. Unable to display waiver.";
    }

    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };
  }, [bookingId]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEOHead
        title="Thank You for Your Booking | Son's Guadalupe"
        description="Your booking is confirmed! Complete your waiver and forward it to all adult guests before your visit."
        noIndex
      />
      <Header />
      <main className="flex-1">
        <section className="py-16 md:py-24 bg-muted/30">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              Thank you!
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
              We just emailed your booking receipt and rental agreement along with a shareable waiver link. You may complete your waiver below.
            </p>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div id="waiver-container" className="flex justify-center items-center min-h-[200px]"></div>
            
            <div className="mt-8 text-center max-w-2xl mx-auto space-y-4">
              <p className="text-primary font-bold">
                Please forward the Waiver to all adult guests if you have not done so already.
              </p>
              <p className="text-muted-foreground">
                <strong className="text-foreground">Please Note:</strong> Everyone in your group (adults must also sign for minors) must sign a waiver before entering the property. You can forward the rental agreement/waiver from the email we just sent you.
              </p>
              <p className="text-muted-foreground">
                Need Help? Call us at: <a href="tel:877-577-7667" className="text-primary hover:underline font-medium">877-577-7667</a>
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
